import api from "@/lib/api";

export async function fetchOrganizations() {
  const { data } = await api.get("/platform/organizations");
  return data?.items || [];
}

export async function createOrganization(payload) {
  const { data } = await api.post("/platform/organizations", payload);
  return data;
}

export async function updateOrganization(id, payload) {
  const { data } = await api.put(`/platform/organizations/${id}`, payload);
  return data;
}

export async function suspendOrganization(id) {
  const { data } = await api.post(`/platform/organizations/${id}/suspend`);
  return data;
}

export async function activateOrganization(id) {
  const { data } = await api.post(`/platform/organizations/${id}/activate`);
  return data;
}

export async function fetchPlatformLicenses(organizationId) {
  const { data } = await api.get("/platform/licenses", {
    params: organizationId ? { organization_id: organizationId } : {},
  });
  return data?.items || [];
}

export async function createPlatformLicense(payload) {
  const { data } = await api.post("/platform/licenses", payload);
  return data;
}

export async function patchLicenseModules(licenseId, modules) {
  const { data } = await api.post(`/platform/licenses/${licenseId}/modules`, { modules });
  return data;
}

export async function fetchPlatformUsers(organizationId) {
  const { data } = await api.get("/platform/users", {
    params: organizationId ? { organization_id: organizationId } : {},
  });
  return data?.items || [];
}

export async function createPlatformUser(payload) {
  const { data } = await api.post("/platform/users", payload);
  return data;
}

export async function updatePlatformUser(userId, payload) {
  const { data } = await api.put(`/platform/users/${userId}`, payload);
  return data;
}

export async function fetchPlatformUserDeleteEligibility(userId) {
  const { data } = await api.get(`/platform/users/${userId}/delete-eligibility`);
  return data;
}

export async function deletePlatformUser(userId) {
  const { data } = await api.delete(`/platform/users/${userId}`);
  return data;
}

export async function fetchPlatformModules() {
  const { data } = await api.get("/platform/modules");
  return data?.items || [];
}

export async function runCommercialOnboarding(payload) {
  const { data } = await api.post("/platform/onboarding", payload);
  return data;
}

export async function fetchPlatformAudit(params = {}) {
  const { data } = await api.get("/platform/audit", { params });
  return data?.items || [];
}

export async function fetchPlatformDashboard() {
  const { data } = await api.get("/platform/dashboard");
  return data;
}

export async function fetchPlatformSatHealth(organizationId) {
  const { data } = await api.get("/platform/sat-health", {
    params: organizationId ? { organization_id: organizationId } : {},
  });
  return data;
}

export async function fetchSatRobotStatus() {
  const { data } = await api.get("/platform/sat-robot");
  return data;
}

export async function setSatRobotEnabled({ enabled, reason = "" }) {
  const { data } = await api.put("/platform/sat-robot", { enabled, reason });
  return data;
}

export async function unstickSatRobotQueue() {
  const { data } = await api.post("/platform/sat-robot/unstick");
  return data;
}

export async function reenqueueSatRobot() {
  const { data } = await api.post("/platform/sat-robot/reenqueue");
  return data;
}

/** Comercial 2C — solicitudes formales de licencia (bandeja BNT). */
export async function listPlatformLicenseRequests(filters = {}) {
  const params = {};
  if (filters.status) params.status = filters.status;
  if (filters.owner_user_id) params.owner_user_id = filters.owner_user_id;
  if (filters.rfc) params.rfc = filters.rfc;
  if (filters.organization_id) params.organization_id = filters.organization_id;
  if (filters.tenant_buyer_id) params.tenant_buyer_id = filters.tenant_buyer_id;
  if (filters.buyer_id) params.buyer_id = filters.buyer_id;
  if (filters.buyer_code) params.buyer_code = filters.buyer_code;
  if (filters.org_code) params.org_code = filters.org_code;
  const { data } = await api.get("/platform/license-requests", { params });
  return data?.items || [];
}

export async function getPlatformLicenseRequest(id) {
  const { data } = await api.get(`/platform/license-requests/${id}`);
  return data;
}

export async function updatePlatformLicenseRequestStatus(id, payload) {
  const { data } = await api.patch(`/platform/license-requests/${id}/status`, payload);
  return data;
}

export async function getPlatformLicenseRequestFulfillPreview(id) {
  const { data } = await api.get(`/platform/license-requests/${id}/fulfill-preview`);
  return data;
}

export async function fulfillPlatformLicenseRequest(id, payload) {
  const { data } = await api.post(`/platform/license-requests/${id}/fulfill`, payload);
  return data;
}

export function platformPaymentProofDownloadUrl(requestId) {
  return `/api/platform/license-requests/${requestId}/payment-proof`;
}

export async function validatePlatformPaymentProof(requestId, payload) {
  const { data } = await api.post(
    `/platform/license-requests/${requestId}/payment-validation`,
    payload,
  );
  return data;
}

/** PR B — herramientas comerciales controladas (diagnóstico, reset, licencia web). */
export async function diagnoseCommercialTools(params = {}) {
  const { data } = await api.get("/platform/commercial-tools/diagnose", { params });
  return data;
}

export async function previewCommercialReset(payload) {
  const { data } = await api.post("/platform/commercial-tools/reset-preview", payload);
  return data;
}

export async function applyCommercialReset(payload) {
  const { data } = await api.post("/platform/commercial-tools/reset", payload);
  return data;
}

export async function suspendCommercialWebLicense(payload) {
  const { data } = await api.post("/platform/commercial-tools/license/suspend", payload);
  return data;
}

export async function reactivateCommercialWebLicense(payload) {
  const { data } = await api.post("/platform/commercial-tools/license/reactivate", payload);
  return data;
}

export async function updateCommercialWebLicenseModules(payload) {
  const { data } = await api.post("/platform/commercial-tools/license/modules", payload);
  return data;
}

export async function renewCommercialWebLicense(payload) {
  const { data } = await api.post("/platform/commercial-tools/license/renew", payload);
  return data;
}

export async function previewTestBuyerPurge(email) {
  const { data } = await api.get("/platform/commercial-tools/test-buyer-purge/preview", {
    params: { email: email.trim() },
  });
  return data;
}

export async function applyTestBuyerPurge(payload) {
  const { data } = await api.post("/platform/commercial-tools/test-buyer-purge", payload);
  return data;
}

/** Comercial 3D — constancia PDF de aceptación legal (plataforma). */
export function platformAgreementAcceptancePdfUrl(acceptanceId) {
  const id = String(acceptanceId || "").trim();
  if (!id) return "";
  return `/api/platform/agreement-acceptances/${encodeURIComponent(id)}/pdf`;
}

export async function fetchCommercialPlansCatalog() {
  const { data } = await api.get("/platform/commercial-plans");
  return data;
}

export async function saveCommercialPlansDraft(payload) {
  const { data } = await api.put("/platform/commercial-plans/draft", payload);
  return data;
}

export async function fetchCommercialPlansImpact(draftId) {
  const { data } = await api.get(`/platform/commercial-plans/draft/${draftId}/impact`);
  return data;
}

export async function publishCommercialPlans(payload) {
  const { data } = await api.post("/platform/commercial-plans/publish", payload);
  return data;
}

export async function rollbackCommercialPlans(payload) {
  const { data } = await api.post("/platform/commercial-plans/rollback", payload);
  return data;
}

export async function fetchCommercialPlansMigrationPreflight() {
  const { data } = await api.get("/platform/commercial-plans/migration/preflight");
  return data;
}

export async function applyCommercialPlansMigration(payload) {
  const { data } = await api.post("/platform/commercial-plans/migration/apply", payload);
  return data;
}

export async function fetchOrganizationSubscriptions(organizationId) {
  const { data } = await api.get("/platform/subscriptions", {
    params: organizationId ? { organization_id: organizationId } : {},
  });
  return data?.items || [];
}

export async function runSubscriptionAction(payload) {
  const { data } = await api.post("/platform/subscriptions/action", payload);
  return data;
}

/** Fase 4.96B — monitoreo primer ciclo SAT (solo lectura, platform_designer). */
export async function fetchSatCycleMonitor(rfc) {
  const { data } = await api.get("/sat/admin/cycle-monitor", {
    params: { rfc: (rfc || "").trim().toUpperCase() },
  });
  return data;
}
